import LayoutContainer from 'components/Common/LayoutContainer'
import LineChartLineIcon from 'components/Luxkit/Icons/line/LineChartLineIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'

const Banner = styled(LayoutContainer)`
width: 100%;
background-color: ${props => props.theme.palette.messaging.fast.light};
color: ${props => props.theme.palette.messaging.fast.main};
padding: ${rem(12)};
line-height: ${rem(12)};
align-items: center;
display: flex;
> * + * {
  margin-left: ${rem(4)};
}

&.orange {
  background-color: ${props => props.theme.palette.messaging.warning.light};
  color: ${props => props.theme.palette.neutral.one};
}
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${mediaQueryUp.tablet} {
    flex-direction: row;
  }
`

interface Props {
  urgencyBannerColourExperimentVariant: string;
}

function UrgencyBanner(props: Props) {
  return (
    <Banner className={cn({ orange: props.urgencyBannerColourExperimentVariant === '1' })}>
      <LineChartLineIcon />
      <TextContainer>
        <BodyText variant="medium"><b>Sell out alert</b>&nbsp;- Very limited rooms left on your preferred dates</BodyText>
      </TextContainer>
    </Banner>
  )
}

export default UrgencyBanner
